import React from 'react';

const LOSHU_ORDER = [4, 9, 2, 3, 5, 7, 8, 1, 6];

const colorMap = {
  1: 'text-red-500',
  2: 'text-blue-500',
  3: 'text-yellow-500',
  4: 'text-green-500',
  5: 'text-purple-500',
  6: 'text-indigo-500',
  7: 'text-pink-500',
  8: 'text-orange-500',
  9: 'text-teal-500'
};

function LoshuGrid({ entities = [], mulank, bhagyank }) {
  // Prepare digit entries for rendering
  const digitRenderMap = {};

  // Initialize map with empty arrays for 1–9
  for (let i = 1; i <= 9; i++) {
    digitRenderMap[i] = [];
  }

  // Count base digits from entities
  entities.forEach((num) => {
    if (num >= 1 && num <= 9) {
      digitRenderMap[num].push('normal');
    }
  });

  // Add one underlined entry for mulank
  if (mulank >= 1 && mulank <= 9) {
    digitRenderMap[mulank].push('underline');
  }

  // Add one underlined entry for bhagyank, only if different
  if (bhagyank >= 1 && bhagyank <= 9 && bhagyank !== mulank) {
    digitRenderMap[bhagyank].push('underline');
  }

  const renderCell = (num) => {
    const entries = digitRenderMap[num];

    return (
      <div
        key={num}
        className="w-20 h-20 border border-gray-300 flex flex-wrap items-center justify-center text-xl font-semibold text-center p-1"
      >
        {entries.length > 0 ? (
          entries.map((entry, idx) => (
            <span
              key={idx}
              className={`mx-[2px] ${colorMap[num]} ${
                entry === 'underline' ? 'underline underline-offset-4' : ''
              }`}
            >
              {num}
            </span>
          ))
        ) : (
          <span className="text-gray-300">{num}</span>
        )}
      </div>
    );
  };

  return (
    <div className="grid grid-cols-3 gap-[2px] bg-white border border-gray-200 rounded-md">
      {LOSHU_ORDER.map(renderCell)}
    </div>
  );
}

export default LoshuGrid;
